import { Link, useLocation, useNavigate } from "react-router-dom";
import { Compass, LogOut, Store, User as UserIcon, Map as MapIcon, Share2, Crown } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../lib/auth";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const onMapPage = location.pathname === "/map";

  return (
    <header
      data-testid="app-header"
      className={`${onMapPage ? "absolute" : "sticky"} top-0 left-0 right-0 z-[1000]`}
      style={{
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        background: "rgba(255,251,245,0.85)",
        borderBottom: "1px solid rgba(0,0,0,0.05)",
      }}
    >
      <div className="max-w-[1800px] mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group shrink-0">
          <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-[#FF6B35] to-[#E84A1F] flex items-center justify-center text-white shadow-lg shadow-[#FF6B35]/30 group-hover:scale-105 group-hover:rotate-3 transition-all">
            <Compass size={20} strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-black text-xl text-[#1A1A1A] tracking-tighter">
              Run<span className="text-[#FF6B35]">Spot</span>
            </div>
            <div className="uppercase-label text-[#00A6B3] text-[9px]">Kosa ou fé aujourd'hui ?</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1 text-sm font-semibold text-[#1A1A1A]">
          <Link to="/" data-testid="nav-explore" className="px-3 py-2 rounded-full hover:bg-[#FAF1E1] transition-colors">Explorer</Link>
          <Link to="/map" data-testid="nav-map" className="px-3 py-2 rounded-full hover:bg-[#FAF1E1] transition-colors flex items-center gap-1.5">
            <MapIcon size={15} /> Carte
          </Link>
          <Link to="/merchant" data-testid="nav-merchant" className="px-3 py-2 rounded-full hover:bg-[#FAF1E1] transition-colors flex items-center gap-1.5">
            <Store size={15} /> Commerçant
          </Link>
          {user?.is_admin && (
            <Link to="/admin" data-testid="nav-admin" className="px-3 py-2 rounded-full bg-gradient-to-r from-[#FF6B35] to-[#E84A1F] text-white hover:opacity-90 transition-opacity flex items-center gap-1.5 font-bold shadow-md shadow-[#FF6B35]/20">
              <Crown size={15} /> Admin
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FAF1E1]">
                <UserIcon size={13} />
                <span className="text-sm font-medium" data-testid="user-name">{user.name}</span>
              </div>
              <Button
                onClick={() => { logout(); navigate("/"); }}
                data-testid="logout-btn"
                variant="ghost"
                size="icon"
                className="rounded-full"
              >
                <LogOut size={16} />
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="header-login-link" className="hidden sm:block">
                <Button variant="ghost" className="rounded-full font-semibold">Connexion</Button>
              </Link>
              <Link to="/register" data-testid="header-register-link">
                <Button className="rounded-full bg-gradient-to-r from-[#FF6B35] to-[#E84A1F] hover:opacity-90 text-white font-semibold shadow-md shadow-[#FF6B35]/30 px-5">
                  Inscription
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
